var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.216 13.4731H9.01389C8.25264 13.4731 7.63641 14.0893 7.63641 14.8506V21.0372H12.216V13.4731V13.4731Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4196 7.9751H13.5829C12.8217 7.9751 12.2054 8.59137 12.2054 9.35262V21.0252H16.785V9.35262C16.785 8.59137 16.1809 7.9751 15.4196 7.9751Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9954 15.5273H16.7933V21.0253H21.3729V16.9049C21.3608 16.1436 20.7446 15.5273 19.9954 15.5273Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8748 26.5832H18.1248C24.1664 26.5832 26.5831 24.1665 26.5831 18.1248V10.8748C26.5831 4.83317 24.1664 2.4165 18.1248 2.4165H10.8748C4.83311 2.4165 2.41644 4.83317 2.41644 10.8748V18.1248C2.41644 24.1665 4.83311 26.5832 10.8748 26.5832Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default __webpack_public_path__ + "static/media/goals.60af8b0573d1551ac09f2994d57e78a7.svg";
export { ForwardRef as ReactComponent };